var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportToJupyter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    clipRule: "evenodd",
    d: "M12.6518 2.23886C12.6704 2.66595 12.3408 3.02573 11.9183 3.0443C11.4959 3.06286 11.1384 2.73094 11.1198 2.30618C11.1013 1.87909 11.4309 1.51931 11.8533 1.50074C12.2758 1.48217 12.6332 1.8141 12.6518 2.23886ZM8.17669 11.3284C6.13177 11.3284 4.34914 10.5787 3.42301 9.47384C4.12399 11.4561 5.98786 12.8743 8.17669 12.8743C10.3655 12.8743 12.2294 11.4561 12.9304 9.47384C12.0019 10.581 10.2216 11.3284 8.17669 11.3284ZM12.9304 5.98285C12.0042 4.87799 10.2216 4.12827 8.17669 4.12827C6.13177 4.12827 4.35146 4.87567 3.42301 5.98285C4.12399 3.99828 5.98786 2.58239 8.17669 2.58239C10.3655 2.58239 12.2294 4.00061 12.9304 5.98285ZM5.37042 13.4847C5.39363 14.0209 4.98047 14.4759 4.44661 14.4991C3.91275 14.5223 3.46245 14.1045 3.43924 13.5683C3.41603 13.0321 3.82919 12.5772 4.36305 12.554C4.89691 12.5308 5.34721 12.9486 5.37042 13.4847ZM3.06551 3.33444C3.07944 3.65011 3.34405 3.89383 3.65508 3.8799C3.96611 3.86597 4.20983 3.60137 4.1959 3.28569C4.18197 2.97002 3.91969 2.7263 3.60633 2.74023C3.2953 2.75415 3.05158 3.01876 3.06551 3.33444Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportToJupyter);
export default __webpack_public_path__ + "static/media/export-to-jupyter.25e58e651f2874e84cb8f00e381c449a.svg";
export { ForwardRef as ReactComponent };